import React, { type FC, type PropsWithChildren } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';

import { useIsManualTrial } from '../../services/eligibility-check/index.tsx';
import type { ManualTrialConditionQuery } from './__generated__/ManualTrialConditionQuery.graphql.ts';

type ManualTrialConditionProps = {
	entitlementId: string;
};

export const ManualTrialCondition: FC<PropsWithChildren<ManualTrialConditionProps>> = ({
	entitlementId,
	children,
}) => {
	const data = useLazyLoadQuery<ManualTrialConditionQuery>(
		graphql`
			query ManualTrialConditionQuery($entitlementId: ID!) {
				growthUnifiedProfile_getEntitlementProfile(entitlementId: $entitlementId) {
					lastKnownTrial {
						trialEndTimeStamp
						trialType
					}
				}
			}
		`,
		{
			entitlementId,
		},
	);

	const trialEndTimeStamp =
		data.growthUnifiedProfile_getEntitlementProfile?.lastKnownTrial?.trialEndTimeStamp ?? undefined;
	const trialType =
		data.growthUnifiedProfile_getEntitlementProfile?.lastKnownTrial?.trialType ?? undefined;

	const isEligible = useIsManualTrial(trialType, trialEndTimeStamp);

	if (!isEligible) {
		return <></>;
	}

	return <>{children}</>;
};
